import { type FC } from "react";
import { AgentExecution_Phase } from "gitpod-next-api/gitpod/v1/agent_pb";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { IconWarning } from "@/assets/icons/geist/IconWarning";
import { IconSpinner } from "@/assets/icons/geist/IconSpinner";
import { IconCheckFill } from "@/assets/icons/geist/IconCheckFill";
import { IconClock } from "@/assets/icons/geist/IconClock";
import type { Size } from "@/assets/icons/geist/Size";

export const AgentExecutionStatusIcon: FC<{ agentExecution: PlainAgentExecution; size?: Size }> = ({
    agentExecution,
    size = "base",
}) => {
    if (!agentExecution.status?.phase) {
        return null;
    }

    switch (agentExecution.status.phase) {
        case AgentExecution_Phase.RUNNING: // PHASE_RUNNING
            return <IconSpinner className="animate-spin text-content-orange" size={size} />;
        case AgentExecution_Phase.WAITING_FOR_INPUT: // PHASE_WAITING_FOR_INPUT
            return <IconClock className="text-content-primary" size={size} />;
        case AgentExecution_Phase.STOPPED: // PHASE_STOPPED
            return agentExecution.status.failureMessage ? (
                <IconWarning className="text-content-red" size={size} />
            ) : (
                <IconCheckFill className="text-content-green" size={size} />
            );
        default:
            return null;
    }
};
